function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.253 2.172l.476-.476a3.062 3.062 0 014.33 4.33L6.253 10.83 1.447 6.025a3.062 3.062 0 014.33-4.33z",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgHeartWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.489 11.718",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartWide;